<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="inventoryVerificationDetail commonFormStyles">
            <HeaderNav
                header-title="库位表单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <li>
                    <van-field
                        disabled
                        label="盘点单编号"
                        placeholder="自动生成"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.CheckNo"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="库位编号"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.GridCode"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="库位名称"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.GridName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="仓库名称"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.StockName"
                    ></van-field>
                </li>
                <div class="info_box">
                    <div class="list_item" v-for="(item, index) in formData.materials" :key="index">
                        <p class="title">
                            <span>物料代码：{{ item.MaterialCode }}</span>
                            <span>短描述：{{ item.MaterialShortName }}</span>
                            <span>单位：{{ item.Unit }}</span>
                        </p>
                        <div class="ps_box">
                            <div class="list_item_card list_item_card2">
                                <div>当前库存：</div>
                                <div>
                                    <van-field
                                        disabled
                                        v-model="item.VolumeCurrent"
                                        label="文本"
                                        label-align="right"
                                    >
                                    </van-field>
                                </div>
                            </div>
                            <div class="list_item_card list_item_card2">
                                <div>盘点库存：</div>
                                <div>
                                    <van-field
                                        :disabled="isReadOnly"
                                        v-model="item.VolumeCheck"
                                        label="文本"
                                        placeholder="请输入盘点库存"
                                        label-align="right"
                                        @change="VolumeChangeFun(item)"
                                    >
                                    </van-field>
                                </div>
                            </div>
                            <div :class="['list_item_card', item.VolumeDiffer !== 0 ? 'warning_card' : '']">
                                <div>盘点差异：</div>
                                <div>
                                    <van-field
                                        disabled
                                        v-model="item.VolumeDiffer"
                                        label="文本"
                                        label-align="right"
                                    >
                                    </van-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <li>
                    <van-field
                        disabled
                        label="期间入库"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.DuringInStockVolume"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="期间出库"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.DuringOutStockVolume"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="最大库存"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.VolumeMax"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="盘点差异"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.VolumeDiffer"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="盘点人"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.CheckUserName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="盘点时间"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.CheckTime"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="状态"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.StatusName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="说明"
                        type="textarea"
                        :rows="2"
                        :disabled="isReadOnly"
                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                        v-model="formData.Remarks"
                    ></van-field>
                </li>
            </ul>
            <footer class="currencyFooterStyle">
                <template v-if="!isReadOnly">
                    <van-button
                        :loading="saveLoadung"
                        type="primary"
                        loading-type="spinner"
                        @click="save"
                    >
                        保存
                    </van-button>
                    <van-button
                        :loading="saveLoadung"
                        type="primary"
                        loading-type="spinner"
                        @click="submitFun"
                    >
                        提交
                    </van-button>
                </template>
                <template v-else>
                    <van-button type="primary" loading-type="spinner" @click="backFun">
                        关闭
                    </van-button>
                </template>
            </footer>
            <van-popup v-model="showSelectPopuo" position="bottom" :style="{ height: '40%' }">
                <van-picker
                    show-toolbar
                    title="请选择"
                    :columns="selectList"
                    :value-key="valueKey"
                    @confirm="confirmSelect"
                    @cancel="showSelectPopuo = false"
                ></van-picker>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
export default {
    // 库位表单
    name: 'inventory-verification-detail',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/inventoryVerification') {
            this.$store.commit('noKeepAlive', 'inventory-verification-detail');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            formData: {
                Id: '',
                CheckNo: '',
                GridCode: '',
                GridName: '',
                StockName: '',
                VolumeMax: '',
                VolumeDiffer: '',
                CheckUserName: '',
                CheckTime: '',
                Status: '',
                Remarks: '',
                materials: [{
                    MaterialCode: '',
                    MaterialName: '',
                    MaterialShortName: '',
                }],
            },
            isSave: false,
            shelfCodeList: [],
            gridCategoryList: [],
            selectList: [],
            valueKey: '',
            showSelectPopuo: false,
            popuoType: '',
            materialIndex: 0,
            StatusDatas: [
                {
                    name: '盘点中',
                    value: 0,
                },
                {
                    name: '已提交',
                    value: 1,
                },
                {
                    name: '已退回',
                    value: 2,
                },
                {
                    name: '已确认',
                    value: 3,
                },
            ],
            isReadOnly: false,
            saveLoadung: false,
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        VolumeChangeFun(item) {
            item.VolumeDiffer = NP.minus(item.VolumeCheck || 0, item.VolumeCurrent || 0);
            let nub = 0;
            this.formData.materials.forEach(k => {
                nub = NP.plus(nub, k.VolumeDiffer);
            });
            this.formData.VolumeDiffer = nub;
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            let res = null;
            if (this.$route.query.openType === 'add') {
                res = await this.getPdRequrst(this.$route.query.pdId);
            } else {
                res = await this.getRequrst(this.$route.query.id);
            }
            if (res.Status !== 0 && res.Status !== 2) {
                this.isReadOnly = true;
            }
            if (res) {
                this.formData = res;
                this.formData.StatusName = this.formData.Status !== null ? this.StatusDatas.filter(item => { return item.value === this.formData.Status; })[0].name : '';
            }
        },

        confirmSelect(val, index) {
            if (this.popuoType === 'ShelfCode') {
                this.formData.ShelfCode = val;
            } else if (this.popuoType === 'GridCategory') {
                this.formData.GridCategory = this.selectList[index].Code;
                this.formData.GridCategoryName = this.selectList[index].Name;
                this.formData.materials = [{
                    MaterialCode: '',
                    MaterialName: '',
                    MaterialShortName: '',
                    VolumeCheck: '',
                }];
            }
            this.showSelectPopuo = false;
        },

        // 提交
        async submitFun() {
            if (this.$route.query.openType === 'add' && !this.isSave) {
                this.$toast('请先保存！');
                return;
            }
            try {
                await this.saveRequrst(this.formData);
            } catch (error) {
                Toast(error.ErrorCode.Message);
            }
            const res = await this.submitRequrst();
            if (res) {
                this.$toast.success('提交成功');
                setTimeout(() => {
                    this.$router.isBack = 1;
                    this.$router.replace({
                        name: 'inventoryVerification',
                        params: {
                            saveCallback: true,
                        },
                    });
                }, 1000);
            }
        },

        async save() {
            this.saveLoadung = true;
            try {
                const res = await this.saveRequrst(this.formData);
                if (res) {
                    this.formData = res;
                    this.isSave = true;
                    this.$toast.success('保存成功');
                    this.saveLoadung = false;
                }
            } catch (error) {
                this.saveLoadung = false;
                Toast(error.ErrorCode.Message);
            }
        },
        async backFun() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'inventoryVerification',
                params: {
                    saveCallback: true,
                },
            });
        },

        getRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid_check/get/${id}`);
        },

        getPdRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_grid_check/scan_check/${id}`);
        },
        saveRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/stock_grid_check/save', requestData);
        },
        submitRequrst() {
            return this.$axios.$put('/interfaceApi/procurement/stock_grid_check/submit/' + this.formData.Id);
        },
    },
};
</script>
<style lang="stylus">
.inventoryVerificationDetail
    height 100%
    position relative
    background #f0f0f0
    .info_box
        background #fff
        padding 10rpx
        .van-cell__right-icon
            color #666
        .list_item
            background #fff
            // margin-bottom 15rpx
            box-shadow: 0px 0px 3px 0px #b5b5b5;
            border-radius: 8rpx;
            position relative
            .title
                width 100%
                height 50rpx
                background #F8F8F8
                margin-bottom 0 !important
                display flex
                align-items center
                flex-wrap: wrap
                padding 0 20rpx
                box-shadow: 0px 2px 3px -2px #b5b5b5;
                font-size 14rpx
                font-weight: 550;
                position relative
                border-radius: 8rpx 8rpx 0 0;
                display: flex;
                justify-content: space-between;
                span
                    min-width 50%
                    color: #000 !important
                .btn
                    position absolute
                    top 0
                    right 0
                    color #fff !important
                    font-size 13rpx !important
                    background: #f86565;
                    padding 2rpx 5rpx
                    border-radius: 0 8rpx
                    font-weight: 500 !important;
                    &.btn_ok
                        background #ccc !important
            .ps_box
                padding 15px
                display: flex
                flex-wrap: wrap;
                justify-content: space-between;
                .list_item_card
                    width calc(33.3% - 10rpx)
                    >div
                        &:last-child
                            margin-top: 6rpx
                    input
                        width 100%
                    .van-cell__title
                        display none
                    .van-cell
                        border: none;
                        background #FAFBFE
                        border-radius 6rpx
                .list_item_card2
                    margin-right 12rpx
                .warning_card
                    color #db8468 !important
                    .van-cell
                        background #fff7f4 !important
                        // border: 1px solid #adc7e0;
            p
                margin-bottom 10px
                color #333
                span
                    color #777
                &last-child
                    margin-bottom 0
            >>>.van-button--plain.van-button--danger
                background: #fcebec;
                width: 60rpx;
                height 25rpx
                position absolute
                bottom 25rpx
                right 10rpx
    .formList
        padding 14rpx
        overflow scroll
        li
            .inputAngBtn
                .van-cell
                    padding-bottom 0
</style>
